(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multi-image-comparison-met-review"] && !Shopify.designMode) return;
  try {
    
  function combineMetArtworkGrids() {
    if (window.Shopify?.designMode) return;

    const groups = [];
    document.querySelectorAll('[data-met-artwork-grid]').forEach(grid => {
      const wrapper = grid.closest('.shopify-section');
      if (!wrapper) return;
      const group = groups[groups.length - 1];
      const previous = group?.[group.length - 1];
      if (previous && previous.closest('.shopify-section').nextElementSibling === wrapper) {
        group.push(grid);
      } else {
        groups.push([grid]);
      }
    });

    groups.forEach(grids => {
      if (grids.length < 2 || grids[0].dataset.metGridMerged) return;
      const primary = grids[0];
      const last = grids[grids.length - 1];
      primary.style.setProperty('--met-grid-padding-bottom', last.style.getPropertyValue('--met-grid-padding-bottom'));

      grids.slice(1).forEach(grid => {
        grid.querySelectorAll(':scope > .sec__image-comparison-slider').forEach(card => primary.appendChild(card));
        grid.closest('.shopify-section').style.display = 'none';
      });

      primary.dataset.metGridMerged = 'true';
      const hasVisibleCards = Array.from(primary.children).some(card =>
        card.classList.contains('sec__image-comparison-slider') && card.style.display !== 'none'
      );
      if (hasVisibleCards) {
        primary.style.removeProperty('display');
      } else {
        primary.style.display = 'none';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', combineMetArtworkGrids, { once: true });
  } else {
    combineMetArtworkGrids();
  }

  } catch(e) { console.error(e); }
})();
})();
